import { render, staticRenderFns } from "./franjasNoAsignados.vue?vue&type=template&id=58843fa6&scoped=true&"
import script from "./franjasNoAsignados.vue?vue&type=script&lang=js&"
export * from "./franjasNoAsignados.vue?vue&type=script&lang=js&"
import style0 from "./franjasNoAsignados.vue?vue&type=style&index=0&id=58843fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58843fa6",
  null
  
)

export default component.exports